var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCFlatSeatExtraLegroom = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 28"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#4481b7",
  d: "M0 28V5a5.3 5.3 0 0 1 5.33-5h13.34A5.3 5.3 0 0 1 24 5v23z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#32628d",
  d: "M0 24h24v4H0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.29 3.09v1.15h3.76L13 10l1.14 1.14 5.72-6v3.67H21V3.09zM10 20v-1H6l6-5.76-1.14-1.15-5.72 6.05L5 14H4v6z"
})));
export { SvgCFlatSeatExtraLegroom as ReactComponent };